export function returnMappedOrThrow<InData, OutData, Err>(
  response:
    | { data: InData; error: undefined }
    | { data: undefined; error: Err },
  errorMessage: string,
  mapper: (data: InData) => OutData
): OutData {
  const { data, error } = response;

  if (data == undefined) {
    throw new Error(`${errorMessage}: ${JSON.stringify(error)}`);
  }

  return mapper(data);
}

export function returnOrThrow<Data, Err>(
  response: { data: Data; error: undefined } | { data: undefined; error: Err },
  errorMessage: string
): Data {
  const { data, error } = response;

  if (data == undefined) {
    throw new Error(`${errorMessage}: ${JSON.stringify(error)}`);
  }

  return data;
}

export function throwIfError<Data, Err>(
  response: { data: Data; error: undefined } | { data: undefined; error: Err },
  errorMessage: string
): void {
  const { error } = response;

  if (error != undefined) {
    throw new Error(`${errorMessage}: ${JSON.stringify(error)}`);
  }
}

export function extractIdFromTrn(trn: string): string {
  if (trn.startsWith('trn::')) {
    const trnSegments = trn.split(':');
    if (trnSegments.length > 0) {
      return trnSegments[trnSegments.length - 1];
    }
  }
  return trn;
}
